import React, { PropsWithChildren, useEffect, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { useWidthContext } from '../../providers/Width';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';
import { Image } from '../../importCL';
interface IAdUnitProps extends MappedComponentProperties {
    adUnitPlacement?: 'bottom' | 'right';
    adImage?: string;
    adImageLink?: string;
    mobileAdImage?: string;
    mobileAdImageLink?: string;
    altText?: string;
}

export const AdUnitEditConfig = {
    emptyLabel: 'Ad Unit',
    isEmpty: (props: PropsWithChildren<IAdUnitProps>) => {
        return !props || !props.adImage || props.isInEditor;
    },
};

const AdUnit = (props: PropsWithChildren<IAdUnitProps>): JSX.Element => {
    const { width } = useWidthContext();
    const [adProps, setAdProps] = useState({
        href: props.adImageLink,
        src: props.adImage,
        alt: props.altText,
    });

    useEffect(() => {
        setAdProps({
            ...adProps,
            href: width > 768 ?props.adImageLink : props.mobileAdImageLink,
            src: width > 768 ? props.adImage : props.mobileAdImage,
        });
    }, [width]);

    //Paragraph number props currently has no effect on frontend/styling/use

    //Class name is ArticleImageUnit for adblock reasons
    return (
        <div id='ad-unit' className={`${props.adUnitPlacement === 'right' ? 'relative md:float-none float-right ml-5 md:ml-0 mb-5' : ''}`}>
            {adProps.href ? (
                <LinkWrapper className='Image__link' href={adProps.href} target='_blank'><Image loading='lazy' src={adProps.src} alt={adProps.alt} /></LinkWrapper>
            ) : (
                <Image loading='lazy' {...adProps} />
            )}
        </div>
    );
};

export default AdUnit;
